// extracted by mini-css-extract-plugin
export default {"autoComplete":"z5-z","error":"A5-z","disabled":"B5-z"};